<form [formGroup]="appointmentForm">
  <div class="row mx-0">
    <div class="col-6 pl-2">
      <mat-form-field *ngIf="packageMode" [floatLabel]="'always'" class="w-100">
        <mat-select
          name="packages"
          placeholder="Select Package"
          kendoTooltip
          tooltipClass="em-tooltip"
          [panelClass]="'mat-dropdown-52vh'"
          [disableOptionCentering]="true"
          [title]="
            editAppointment?.plannedTreatmentId
              ? 'Cannot change service for a scheduled planned treatment. Create a new tx or a new appointment unrelated to the tx.'
              : ''
          "
          [disabled]="
            editAppointment?.paymentStatus === PaymentStatus.Paid ||
            editAppointment?.service?.isLocked ||
            editAppointment?.plannedTreatmentId
          "
          [(value)]="selectedPackageId"
          (selectionChange)="serviceSelectionChange()"
          (openedChange)="resetSearch(); serviceSearch.value = ''"
        >
          <div class="dropdown-search sticky-top px-2">
            <i class="fas fa-search pr-2"></i>
            <input
              type="text"
              placeholder="Search..."
              #serviceSearch
              (keyup)="onServiceSearchKey($event)"
              (keydown)="$event.stopPropagation()"
            />
          </div>
          <div *ngIf="!searchFilteredPackages || searchFilteredPackages.length === 0" class="no-results">
            No results found
          </div>
          <mat-option *ngFor="let pkg of searchFilteredPackages" [value]="pkg?.id">
            <div class="d-flex justify-content-between align-items-center">
              <div>{{ pkg.name }} (x{{ pkg.quantity }})</div>
              <div>
                {{ (pkg.price ? pkg.price : pkg.quantity * pkg.serviceTemplate.defaultPrice) | currency }}
              </div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="!packageMode" [floatLabel]="'always'" class="w-100">
        <mat-select
          name="services"
          placeholder="Select Service"
          kendoTooltip
          tooltipClass="em-tooltip"
          [panelClass]="'mat-dropdown-52vh'"
          [disableOptionCentering]="true"
          [title]="
            editAppointment?.plannedTreatmentId
              ? 'Cannot change service for a scheduled planned treatment. Create a new tx or a new appointment unrelated to the tx.'
              : ''
          "
          [disabled]="
            editAppointment?.paymentStatus === PaymentStatus.Paid ||
            editAppointment?.service?.isLocked ||
            editAppointment?.plannedTreatmentId
          "
          [(value)]="selectedServiceTemplateId"
          (selectionChange)="serviceSelectionChange()"
          (openedChange)="resetSearch(); serviceSearch.value = ''"
        >
          <div class="dropdown-search sticky-top px-2">
            <i class="fas fa-search pr-2"></i>
            <input
              type="text"
              placeholder="Search..."
              #serviceSearch
              (keyup)="onServiceSearchKey($event)"
              (keydown)="$event.stopPropagation()"
            />
          </div>
          <div *ngIf="!searchFilteredTemplates || searchFilteredTemplates.length === 0" class="no-results">
            No results found
          </div>
          <mat-option *ngFor="let serviceTemplate of searchFilteredTemplates" [value]="serviceTemplate?.id">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ serviceTemplate.serviceName }}
              </div>
              <div>
                {{ serviceTemplate.defaultPrice | currency }}
              </div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field class="w-100 remove-underline" [floatLabel]="'always'">
        <input
          class="w-100 service-provider-field"
          matInput
          placeholder="Service Provider"
          [readonly]="true"
          [value]="selectedStaff ? selectedStaff?.title : 'Please select provider'"
          [ngClass]="selectedStaff ? '' : 'red-font'"
          [disabled]="editAppointment?.service?.isLocked"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row mx-0">
    <div class="col-6 pl-2 pt-3">
      <label for="startTime" class="custom-label teal-font" [ngClass]="{ disabled: editAppointment?.service?.isLocked }"
        >Start Time</label
      >
      <kendo-timepicker
        class="w-100"
        name="startTime"
        [min]="minTime"
        [max]="maxTime"
        [steps]="{ minute: 5 }"
        [(value)]="startTime"
        (valueChange)="onStartTimeChange($event)"
        [disabled]="editAppointment?.service?.isLocked"
      >
      </kendo-timepicker>
    </div>
    <div class="col-6">
      <mat-form-field class="w-100" [floatLabel]="'always'">
        <mat-select
          placeholder="Duration (minutes)"
          aria-label="Duration"
          [(value)]="calculatedDuration"
          (selectionChange)="onDurationChange($event)"
          [disabled]="editAppointment?.service?.isLocked"
        >
          <mat-option *ngFor="let durOpt of [calculatedDuration].concat(durationOptions)" [value]="durOpt">
            {{ durOpt }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Forms -->
  <div *ngIf="selectedServiceForms?.length > 0" class="row mt-2 mb-3">
    <div class="col pt-0 grey-two-background">
      <div class="row mx-0 mt-3">
        <div class="col px-2">
          <h6 class="sub-heading e-forms-title pl-1">ASSIGN eFORMS</h6>
        </div>
      </div>
      <div class="row mx-0 mb-1">
        <div class="col px-2">
          <div *ngFor="let serviceForm of selectedServiceForms; let index = index">
            <mat-checkbox
              (change)="formsSelectionModel.toggle(serviceForm.clinicForm.id)"
              [checked]="formsSelectionModel.isSelected(serviceForm.clinicForm.id)"
              >{{ serviceForm.clinicForm.name }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Credit Card Payments -->
  <div
    class="p-3 grey-two-background mb-3"
    *ngIf="
      (patient && selectedService?.requireCardOnFile) ||
      (clinic?.staffBookingCancellationPrice > 0 && editAppointment?.onlineBooked)
    "
  >
    <div class="d-flex justify-content-between align-items-center pb-2">
      <h6 class="uppercase">Credit Card Information</h6>
      <div class="align-top mb-1">
        <label class="ml-3 mb-0 teal-font text-truncate d-inline">Cancellation Fee?</label>
        <mat-slide-toggle
          title="Toggle credit card payment"
          [checked]="takeCreditCardPayment"
          (change)="onTakeCreditCardPaymentChanged()"
          class="align-middle"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div class="d-flex flex-column white-background p-2">
      <div class="mb-1">
        Cancellation Fee: <strong>{{ clinic.staffBookingCancellationPrice | currency }}</strong>
      </div>
      <ng-container *ngIf="takeCreditCardPayment; else reasonInput">
        <div [ngSwitch]="clinic.paymentProcessorType">
          <div *ngSwitchCase="PaymentProcessorType.None" class="mt-2 invalid font-weight-bold">
            <mat-label class="label-header">No payment processor selected in Clinic settings.</mat-label>
          </div>
          <div *ngSwitchCase="PaymentProcessorType.EmilyPay">
            <app-converge-payment
              [isDisabled]="!takeCreditCardPayment"
              [patient]="patient"
              [selectedPatientTokenId]="selectedPatientTokenId"
              [requestCreditCard]="requestCreditCard"
              (requestCreditCardChangedEvent)="onRequestCreditCardChanged($event)"
              [cancellationFee]="clinic.onlineBookingCancellationPrice"
              (cardSelectedEvent)="onConvergeCardSelected($event)"
              [showRequestCreditCardButton]="!addMode"
              [appointment]="editAppointment"
            ></app-converge-payment>
          </div>
          <div *ngSwitchCase="PaymentProcessorType.Square">
            <app-square-card
              *ngIf="isSquareLinked"
              [patient]="patient"
              [selectedSquareCardId]="selectedSquareCardId"
              [requestCreditCard]="requestCreditCard"
              (requestCreditCardChangedEvent)="onRequestCreditCardChanged($event)"
              (cardSelectedEvent)="onSquareCardSelected($event)"
              [showRequestCreditCardButton]="!addMode"
              [appointment]="editAppointment"
            ></app-square-card>
          </div>
        </div>
      </ng-container>
      <ng-template #reasonInput>
        <mat-label class="label-header teal-font mt-2"
          >Reason for not charging credit card: <span class="text-danger">*</span></mat-label
        >
        <textarea
          required
          rows="1"
          placeholder="Add reason"
          class="form-control input-field mb-2"
          [(ngModel)]="reasonCancellationNotCharged"
          [ngModelOptions]="{ standalone: true }"
        ></textarea>
      </ng-template>
    </div>
  </div>

  <!-- Resources -->
  <div
    class="mx-0"
    *ngIf="selectedService?.serviceTemplateResources?.length && selectedService.serviceTemplateResources.length > 0"
  >
    <div class="row mx-0 mt-3">
      <div class="col px-2">
        <h6 class="sub-heading pl-1">ASSIGN RESOURCES</h6>
      </div>
    </div>
    <div class="row mx-0 mb-2">
      <div class="col-6">
        <mat-form-field
          class="w-100 remove-underline"
          [floatLabel]="'always'"
          *ngIf="servicesService.hasSingleRoom(selectedService.serviceTemplate) && roomResources[0]?.disabled"
        >
          <input
            class="w-100 service-provider-field"
            matInput
            placeholder="Room"
            [readonly]="true"
            [value]="servicesService.getFirstRoom(selectedService.serviceTemplate)?.name"
            [disabled]="editAppointment?.service?.isLocked"
          />
        </mat-form-field>
        <mat-form-field
          [floatLabel]="'always'"
          class="w-100"
          *ngIf="
            servicesService.hasMultipleRooms(selectedService.serviceTemplate) ||
            (roomResources.length === 1 && !roomResources[0].disabled)
          "
        >
          <mat-select
            formControlName="roomSelect"
            placeholder="Select Room"
            multiple="false"
            [compareWith]="onCompareResource"
            [required]="!editAppointment?.service?.isLocked"
            [disabled]="editAppointment?.service?.isLocked"
          >
            <mat-option *ngFor="let resource of roomResources" [value]="resource" [disabled]="resource.disabled">
              {{ resource.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 pl-2">
        <mat-form-field
          class="w-100 remove-underline"
          [floatLabel]="'always'"
          *ngIf="
            servicesService.hasSingleEquipment(selectedService.serviceTemplate) && !equipmentResources[0]?.disabled
          "
        >
          <input
            class="w-100 service-provider-field"
            matInput
            placeholder="Equipment"
            [readonly]="true"
            [value]="servicesService.getFirstEquipment(selectedService.serviceTemplate)?.name"
            [disabled]="editAppointment?.service?.isLocked"
          />
        </mat-form-field>
        <mat-form-field
          [floatLabel]="'always'"
          class="w-100"
          *ngIf="
            servicesService.hasMultipleEquipment(selectedService.serviceTemplate) ||
            (equipmentResources.length === 1 && equipmentResources[0].disabled)
          "
        >
          <mat-select
            formControlName="equipmentSelect"
            placeholder="Select Equipment"
            multiple="false"
            [compareWith]="onCompareResource"
            [required]="!editAppointment?.service?.isLocked"
            [disabled]="editAppointment?.service?.isLocked"
          >
            <mat-option *ngFor="let resource of equipmentResources" [value]="resource" [disabled]="resource.disabled">
              {{ resource.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div *ngIf="addMode" class="row mx-0 pb-3">
    <div class="col px-2">
      <button
        class="btn em-btn em-btn-green mr-2"
        data-test-id="add-and-close-create-appointment-button"
        (click)="validateAndCreateAppointment(true)"
        [disabled]="!isFormValid()"
      >
        Add &amp; Close
      </button>
      <button
        class="btn em-btn em-btn-green mr-2"
        data-test-id="add-create-appointment-button"
        (click)="validateAndCreateAppointment(false)"
        [disabled]="!isFormValid()"
      >
        Add
      </button>
      <button class="btn em-btn em-btn-green mr-2" data-test-id="close-panel-button" (click)="closePanel()">
        Close
      </button>
    </div>
  </div>

  <div *ngIf="!addMode && !editAppointment?.service?.isLocked" class="row mx-0 pb-3">
    <div class="col">
      <button
        class="btn em-btn em-btn-green btn-appt mr-2"
        (click)="validateAndUpdateAppointment(editAppointment)"
        [disabled]="!appointmentForm.valid"
      >
        Update Appointment
      </button>
      <button class="btn em-btn em-btn-green btn-appt" (click)="editAppointment.editing = false">Cancel</button>
    </div>
  </div>
</form>
